"use client";
import { ContentBlockerWrapper } from "@aleksundshantu/aunds-cookie-plugin-react";
import { isEmpty } from "lodash";
import { ReactNode } from "react";
import { useRouter } from "next/compat/router";

interface ExtendedConsentManagementProps {
  children: ReactNode;
  type_consent_management: string;
}

export const ExtendedConsentManagement = ({
  type_consent_management,
  children,
}: ExtendedConsentManagementProps) => {
  const hasConsent = isEmpty(type_consent_management);
  // next/compat/router returns null outside the pages router (e.g. Storybook)
  const router = useRouter();
  const locale = router?.locale;

  return hasConsent ? (
    <>{children}</>
  ) : (
    <ContentBlockerWrapper
      wpApiUrl={process.env.WP_API_URL!}
      platformName={type_consent_management || "unknown"}
      locale={
        locale !== process.env.NEXT_PUBLIC_DEFAULT_LOCALE ? locale : undefined
      }
    >
      {children}
    </ContentBlockerWrapper>
  );
};
